import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import AppRouter from "./AppRouter";
import NotificationList from "./components/NotificationList";

// Export principale con AuthProvider e Router
export default function App() {
  return (
    <NotificationProvider>
      <AuthProvider>
        <AppRouter />
        <NotificationList />
      </AuthProvider>
    </NotificationProvider>
  );
}
